<template>
  <div class="page-swipe">
    <div class="filter-input" @click="handleSearchClick">
      <i class="mint-toast-icon mintui mintui-search search-text">{{filterInitText}}</i>
    </div>
    <mt-swipe>
      <mt-swipe-item v-for="item in swipeItems" :key="item.id">
        <img @click="handleSwipeClick(item)" :src="item.iconUrl" alt>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "mint-ui";
export default {
  name: "pageSwipe",
  component: {
    "mt-swipe": Swipe,
    "mt-swipe-item": SwipeItem
  },
  data() {
    return {};
  },
  props: {
    filterInitText: {
      type: String,
      default: "搜索"
    },
    swipeItems: [Array]
  },
  methods: {
    handleSearchClick() {
      this.$emit("searchClick");
    },
    handleSwipeClick(item) {
      this.$emit("swipeClick", item);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/px2rem.scss";
@import "../../../assets/css/colors.scss";
$swipe-height: px2rem(188);
$filter-input-width: px2rem(343);
$filter-input-height: px2rem(30);
.page-swipe {
  position: relative;
  .filter-input {
    position: absolute;
    width: $filter-input-width;
    top: px2rem(10);
    left: px2rem(16);
    height: $filter-input-height;
    border-radius: px2rem(100);
    padding: 0 px2rem(12);
    line-height: $filter-input-height;
    z-index: 100;
    background-color: rgba($color: #fff, $alpha: 0.8);
    .search-text {
      text-align: left;
      color: $gray;
      font-size: px2rem(12);
    }
  }
  .mint-swipe {
    height: $swipe-height;
    color: #fff;
    text-align: center;
    .mint-swipe-item {
      height: $swipe-height;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .slide1 {
      background-color: aqua;
    }
    .slide2 {
      background-color: gray;
    }
    .slide3 {
      background-color: yellow;
    }
  }
}
</style>


